module.exports = __webpack_public_path__ + "img/circle-phone-hangup.201feb69.svg";